export const V1A_NAMESPACE = 'components/trial/lp/v1a';

/** Every raster the page ships lives under these two folders (AVIF + WebP, and MP4 + WebM for the clips). */
export const V1A_IMG = '/assets/images/trial/v1a';
export const V1A_VIDEO = '/assets/video/trial/v1a';

/** `<img fetchpriority>` without React 18's unknown-prop warning (React only learns `fetchPriority` in 19). */
export const HIGH_FETCH_PRIORITY = { fetchpriority: 'high' } as Record<string, string>;
